import moment from 'utils/momentInstanse'

const getSeparatedSeriesNameAndUnit = (str = '') => {
  if (typeof str !== 'string') return str
  return str.split('|')
}

export const chart = {
  toolbar: {
    show: false,
  },
  zoom: {
    enabled: false,
  },
  fontFamily: 'Source Sans Pro, Helvetica, sans-serif',
  foreColor: 'rgba(131, 137, 146, 1)',
  height: '100%',
  width: '100%',
}

export const grid = {
  show: true,
  borderColor: '#D8DBDF',
  strokeDashArray: 0,
  position: 'back',
  xaxis: {
    lines: {
      show: true,
    },
  },
  yaxis: {
    lines: {
      show: true,
    },
  },
  row: {
    colors: ['rgb(231, 232, 234)'],
    opacity: 0.5,
  },
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
}

export const dataLabels = {
  enabled: false,
}

export const stroke = {
  show: true,
  curve: 'smooth',
  width: 3.5,
  lineCap: 'butt',
}

export const fill = {
  type: ['gradient'],
  gradient: {
    shade: 'light',
    type: 'vertical',
    shadeIntensity: 0,
    opacityFrom: 0.5,
    opacityTo: 0.1,
    stops: [30, 100, 100],
  },
}

export const xaxis = {
  type: 'datetime',
  tickPlacement: 'between',
  axisBorder: {
    show: false,
  },
  axisTicks: {
    show: false,
  },
  tooltip: {
    enabled: false,
  },
  crosshairs: {
    show: true,
    width: 1,
    position: 'back',
    opacity: 0.9,
    stroke: {
      color: 'rgb(21, 31, 49)',
      width: 1,
    },
  },
}

export const yaxis = {
  tickAmount: 4,
  min: 0,
  decimalsInFloat: 0,
  forceNiceScale: true,
  axisTicks: {
    show: true,
    borderType: 'dotted',
    color: '#D8DBDF',
    width: 15,
    offsetX: 7,
    offsetY: 0.5,
  },
  crosshairs: {
    show: false,
  },
  tooltip: {
    enabled: false,
  },
  labels: {
    show: true,
    align: 'right',
    offsetX: -15,
    offsetY: 0,
    rotate: 0,
  },
}

export const yaxisTemperature = {
  min: 0,
  max: 50,
  show: false,
}

export const markers = {
  size: 0,
  colors: ['#ffffff'],
  strokeColors: ['#0f0f0f'],
  strokeWidth: 2,
  hover: {
    size: 6,
    sizeOffset: 3,
  },
}

export const tooltip = {
  enabled: true,
  custom: function (props) {
    const { w, dataPointIndex, seriesIndex, series } = props

    const _date = moment
      .utc(w.globals.seriesX[seriesIndex][dataPointIndex])
      .format('DD MMM, yyyy HH:mm')

    if (series.length > 1) {
      const dataToTooltip = series
        .map((serie, i) => {
          if (serie.length) {
            const [unit, name = ''] = getSeparatedSeriesNameAndUnit(
              w.globals.seriesNames[i]
            )

            return {
              backgroundColor: w.globals.seriesColors[i],
              name: name ? name + ':' : '',
              value: Number(serie[dataPointIndex]),
              unit: unit,
            }
          }
        })
        .sort((a, b) => b['value'] - a['value'])

      return `<div class='tooltip_container multi'>
                <span class='xaxis_text'>${_date}</span>
                ${dataToTooltip
                  .map((item) => {
                    if (item) {
                      return `
                      <div class='series_row'>
                        <div class='legend_color'
                        style='background: ${item.backgroundColor};'></div>
                        <span class='yaxis_text'>
                         ${item.name} ${item.value.toFixed(2)} 
                         <span>${item.unit}</span>
                        </span>
                      </div>
                    `
                    }
                  })
                  .join('')}
            </div>`
    }

    const [unit, name = ''] = getSeparatedSeriesNameAndUnit(
      w.globals.seriesNames[seriesIndex]
    )

    return `<div class='tooltip_container'>
                <span class='xaxis_text'>${_date}</span>
                <span class='yaxis_text'>
                   ${name ? name + ':' : ''} ${Number(
      series[seriesIndex][dataPointIndex]
    ).toFixed(2)} 
                    <span>${unit}</span>
                </span>
            </div>`
  },
}

export const legend = {
  show: false,
}

export const plotOptions = {
  heatmap: {
    radius: 4,
    enableShades: true,
    shadeIntensity: 0.8,
    colorScale: {
      ranges: [
        {
          from: 0,
          to: 1,
          color: '#DBDEDF',
        },
        {
          from: 1,
          to: 100,
          color: '#00A100',
        },
      ],
      min: 0,
      max: 100,
    },
  },
  bar: {
    borderRadius: 17,
    horizontal: true,
    barHeight: '65%',
    rangeBarOverlap: false,
    rangeBarGroupRows: false,
  },
}
